import { CheckCircle2, Clock, HardDrive, Users } from "lucide-react";

const services = [
  {
    title: "Gestion du Parc Informatique", subtitle: "Prise en main en quelques minutes",
    description: "Des solutions 100% cloud, que vous installez en quelques clics et gérez en toute simplicité",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4"><h4 className="font-semibold text-gray-900">Appareils</h4><div className="flex gap-2"><div className="w-2 h-2 rounded-full bg-green-500"></div><div className="w-2 h-2 rounded-full bg-yellow-500"></div><div className="w-2 h-2 rounded-full bg-red-500"></div></div></div>
        <div className="space-y-3">
          {[{ n: "MacBook Pro", s: "bg-green-500", c: 45 }, { n: 'iMac 27"', s: "bg-yellow-500", c: 12 }, { n: "Mac Mini", s: "bg-red-500", c: 8 }].map((d, i) => (
            <div key={i} className="flex items-center gap-3 p-2 rounded-lg bg-gray-50">
              <div className={`w-3 h-3 rounded-full ${d.s}`}></div>
              <div className="flex-1"><div className="text-sm font-medium text-gray-900">{d.n}</div><div className="text-xs text-gray-500">{d.c} unités</div></div>
              <CheckCircle2 className="w-4 h-4 text-gray-400" />
            </div>
          ))}
        </div>
      </div>
    ),
  },
  {
    title: "Compte Client", subtitle: "Suivi en temps réel de vos interventions",
    description: "Via votre compte client, restez informé partout de l'avancée des prises en charge et des maintenances sur vos appareils ou ceux de vos collaborateurs.",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4"><h4 className="font-semibold text-gray-900">Mes interventions</h4><div className="px-2 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">2 en cours</div></div>
        <div className="space-y-3">
          {[{ d: "MacBook Pro - J. Dupont", t: "Maintenance préventive", s: "En cours", p: 65, tm: "Il y a 2h", sc: "bg-blue-100 text-blue-700" }, { d: 'iMac 27" - M. Martin', t: "Mise à jour système", s: "Planifiée", p: 0, tm: "Demain 10h", sc: "bg-yellow-100 text-yellow-700" }].map((it, i) => (
            <div key={i} className="p-3 rounded-lg bg-gray-50 border border-gray-200">
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1"><div className="text-sm font-medium text-gray-900">{it.d}</div><div className="text-xs text-gray-500 mt-1">{it.t}</div></div>
                <div className={`px-2 py-1 rounded-full text-xs font-medium ${it.sc}`}>{it.s}</div>
              </div>
              {it.p > 0 && (
                <div className="mt-2"><div className="flex justify-between text-xs text-gray-600 mb-1"><span>Progression</span><span>{it.p}%</span></div><div className="w-full bg-gray-200 rounded-full h-1.5"><div className="h-1.5 rounded-full bg-blue-600" style={{ width: `${it.p}%` }}></div></div></div>
              )}
              <div className="flex items-center gap-1 mt-2 text-xs text-gray-500"><Clock className="w-3 h-3" />{it.tm}</div>
            </div>
          ))}
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200 flex items-center justify-between"><div className="text-xs text-gray-600">Appareils suivis</div><div className="text-sm font-semibold text-gray-900">12 appareils</div></div>
      </div>
    ),
  },
  {
    title: "Sauvegarde et Sécurité", subtitle: "Protection totale de vos données",
    description: "Sauvegardes automatiques, chiffrement avancé et plans de reprise d'activité pour sécuriser votre infrastructure",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4"><h4 className="font-semibold text-gray-900">Sauvegardes</h4><div className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">Actif</div></div>
        <div className="space-y-4">
          <div className="flex items-center justify-between p-3 rounded-lg bg-blue-50">
            <div className="flex items-center gap-3"><HardDrive className="w-5 h-5 text-blue-600" /><div><div className="text-sm font-medium text-gray-900">Backup quotidien</div><div className="text-xs text-gray-500">Dernière sauvegarde: il y a 2h</div></div></div>
            <div className="text-sm font-semibold text-blue-600">2.4 TB</div>
          </div>
          <div className="space-y-2"><div className="flex justify-between text-xs text-gray-600"><span>Espace utilisé</span><span>78%</span></div><div className="w-full bg-gray-200 rounded-full h-2"><div className="bg-blue-600 h-2 rounded-full" style={{ width: "78%" }}></div></div></div>
        </div>
      </div>
    ),
  },
  {
    title: "Support Technique 24/7", subtitle: "Une équipe à votre écoute",
    description: "Support multi-canal avec une équipe certifiée Apple disponible à tout moment pour résoudre vos problèmes",
    ui: (
      <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
        <div className="flex items-center justify-between mb-4"><h4 className="font-semibold text-gray-900">Support</h4><div className="flex items-center gap-1"><div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div><span className="text-xs text-gray-600 ml-1">En ligne</span></div></div>
        <div className="space-y-3">
          {[{ n: "Alexandre Daif", s: "bg-green-500", r: "Expert Apple" }, { n: "Moussa Jaffar", s: "bg-yellow-500", r: "Support technique" }, { n: "Mamadou Tal", s: "bg-green-500", r: "Gestionnaire" }].map((a, i) => (
            <div key={i} className="flex items-center gap-3 p-2 rounded-lg bg-gray-50">
              <div className="relative"><div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white text-xs font-semibold">{a.n.split(" ").map(x => x[0]).join("")}</div><div className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white ${a.s}`}></div></div>
              <div className="flex-1"><div className="text-sm font-medium text-gray-900">{a.n}</div><div className="text-xs text-gray-500">{a.r}</div></div>
              <Users className="w-4 h-4 text-gray-400" />
            </div>
          ))}
        </div>
      </div>
    ),
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-20 lg:py-32 bg-gradient-to-br from-slate-50/50 via-background to-indigo-50/30 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(99,102,241,0.03),transparent_50%)] pointer-events-none"></div>
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl lg:text-5xl font-bold text-foreground mb-6">Nos Services</h2>
          <p className="text-lg lg:text-xl text-muted-foreground leading-relaxed">Une gamme complète de services pour garantir le bon fonctionnement de votre infrastructure</p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
          {services.map((s, i) => (
            <div key={i} className="space-y-4 flex flex-col">
              <div className="space-y-1">
                <h3 className="text-xl lg:text-2xl font-bold text-foreground">{s.title}</h3>
                <p className="text-sm font-medium text-primary">{s.subtitle}</p>
              </div>
              <div className="transform hover:scale-[1.02] transition-transform duration-300 flex-shrink-0">{s.ui}</div>
              <p className="text-muted-foreground leading-relaxed text-base flex-grow">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
